import { authorizedAction } from 'api'
import { ErrorProp } from './'
import { UserType } from 'types'
import { TEACHER, TEACHER_DC } from '../constants'

export type DeactivateTMATTResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type DeactivateTMATTProps = {
  userId?: string
  userType?: UserType
}

export async function deactivateTMATT({
  userId,
  userType,
}: DeactivateTMATTProps): Promise<DeactivateTMATTResponseProps> {
  try {
    if (userType !== TEACHER && userType !== TEACHER_DC) {
      throw new Error('Invalid user type')
    }
    const action =
      userType === TEACHER
        ? 'Teacher.LMSDeactivate'
        : 'Teacher.LMSDeactivateRefresher'

    const response = await authorizedAction({
      action: action,
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as DeactivateTMATTResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
